customElements.define(
  'countdown-timer',
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this._render();
      this._interval = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _remaining() {
      return Math.max(0, new Date(this.getAttribute('time')) - Date.now());
    }

    _render() {
      const small = this.hasAttribute('small');
      this.innerHTML = `
        <div class="countdown-timer${small ? ' countdown-timer--small' : ''}">
          <div class="time">
            <div class="time-part hours" data-period="hours"><span class="number">00</span></div>
            <span class="separator"></span>
            <div class="time-part minutes" data-period="minutes"><span class="number">00</span></div>
            <span class="separator"></span>
            <div class="time-part seconds" data-period="seconds"><span class="number">00</span></div>
          </div>
          <div class="refresh" hidden>
            <a class="btn" onclick="location.reload()">
              <i class="icon-arrows-cw"></i>
              Please Refresh the Page
            </a>
          </div>
        </div>
      `;
      this._tick();
    }

    _tick() {
      const remaining = this._remaining();
      const timer = this.querySelector('.countdown-timer');
      if (!timer) return;

      if (remaining <= 0) {
        clearInterval(this._interval);
        timer.querySelector('.time').hidden = true;
        timer.querySelector('.refresh').hidden = false;
        return;
      }

      const total = Math.floor(remaining / 1000);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;

      timer.querySelector('[data-period="hours"] .number').textContent = h
        .toString()
        .padStart(2, '0');
      timer.querySelector('[data-period="minutes"] .number').textContent = m
        .toString()
        .padStart(2, '0');
      timer.querySelector('[data-period="seconds"] .number').textContent = s
        .toString()
        .padStart(2, '0');
    }
  },
);
